import _ from "lodash"
import jMoment from 'jalali-moment'

export default {
  template: `
    <div class="p-3 form-container">
    <!--        <nk-dropdown class="mb-3" :data="types" :options="{multiSelection:false}" v-model="selectedType"></nk-dropdown>-->
    <select class="mb-3 p-1 w-100 m-dropdown-input.selected-items" v-on:change="handleSelectedOption">
      <option class="item " v-for="item in types" :value="item.id">{{ item.name }}</option>
    </select>
    <nk-input v-model="filterText" @update:modelValue="(value)=>this.filterText=value" />

    </div>
  `,
  props: {
    options: { type: Object }
  },
  data: function () {
    const types = [
      { id: 'contains', func: 'isAfter', name: 'شامل' },
      { id: 'startsWith', func: 'isBefore', name: 'شروع با' },
      { id: 'endsWith', func: 'isBefore', name: 'پایان با' },
      { id: 'equals', func: 'isSame', name: 'برابر با' },
    ]
    return {
      filterText: null,
      selectedType: types[0],
      types: types,
      timer: null,
      settings: {
        debounceMs: 0,
      }
    }
  },
  mounted() {
    this.settings = _.merge(this.settings, this.options)
    this.settings.debounceMs = this.params.debounceMs
    this.settings.selectedType && (this.selectedType = this.settings.selectedType)
  },
  watch: {
    filterText(newFilterText, oldFilterText) {
      this.applyFilter()
    },
  },
  methods: {
    applyFilter() {
      if (this.timer)
        clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        this.params.filterChangedCallback()
      }, this.settings.debounceMs)
    },
    isFilterActive() {
      return (
        this.filterText !== null &&
        this.filterText !== undefined &&
        this.filterText !== ''
      )
    },
    handleSelectedOption(event) {
      // console.log(event.target.value)
      this.selectedType = this.types.find(x => x.id == event.target.value)
      if (this.filterText) this.params.filterChangedCallback()
    },
    doesFilterPass(params) {
      const value = this.params.valueGetter(params)
      const valueFormatted = this.params?.colDef?.valueFormatter({ ...params, value: value })
      const functions = {
        equals: (value) => this.filterText == value,
        endsWith: value => value.endsWith(this.filterText),
        startsWith: value => value.startsWith(this.filterText),
        contains: value => value.includes(this.filterText),
      }
      if (this.isFilterActive()) {
        // if (!value) return false;
        let status = !valueFormatted && !value ? false : functions[this.selectedType?.id](valueFormatted ? valueFormatted : value)
        return status
        // return Number(value) > Number(this.filterText);
      }
    },

    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n)
    },

    getModel() {
      return {
        filter: this.filterText,
        filterType: "string",
        type: this.selectedType.id
      }
      // return this.isFilterActive() ? Number(this.filterText) : null;
    },

    setModel(model) {
      this.filterText = model.filter
      this.selectedType = this.types.find(x => x.id === model.type)
    },

    myMethodForTakingValueFromFloatingFilter(value) {
      this.filterText = value
    },
  },
}
